const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const OfficeModal = require("./OfficeModal");
const Checkbox = require("../../core/view/Checkbox");
const LockIcon = require("../LockIcon");
const CopyTable = require("../../core/util/CopyTable");

const styles = require("./styles/ConfirmModal.css");

// TODO: This can later be turned into a view that could be used or trainer and office pages.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "OfficeConfirmModal",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			//This event also appears in GlobalModal but GlobalModal only in
			//MainTrainerContainer.
			showConfirm: function(messageType, messageData) {
				this.setState({
					isModalOpen: true,
					messageType,
					messageData,
				});
			},
		},

		suppressShowConfirm: function() {
			this.props.dispatch({
				type: AT.SUPPRESS_OFFICE_CONFIRM_MODAL,
			});
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
				messageType: null,
				messageData: null,
				doNotShowAgain: false,
			};
		},

		toggleDoNotShow: function() {
			this.setState({doNotShowAgain: !this.state.doNotShowAgain});
		},

		onClose: function() {
			const {messageData} = this.state;
			if (messageData && messageData.onCloseDispatch) {
				this.props.dispatch(messageData.onCloseDispatch);
			}
			this.setState({isModalOpen: false, doNotShowAgain: false});
		},

		onConfirm: function() {
			const {messageData, doNotShowAgain} = this.state;
			if (messageData && messageData.onConfirmDispatch) {
				this.props.dispatch(messageData.onConfirmDispatch);
			}
			if (messageData.doNotShowAgainOption && doNotShowAgain) {
				this.suppressShowConfirm();
			}
			this.setState({isModalOpen: false, doNotShowAgain: false});
		},

		onNotConfirm: function() {
			const {messageData} = this.state;
			if (messageData && messageData.onNotConfirmDispatch) {
				this.props.dispatch(messageData.onNotConfirmDispatch);
			}
			this.setState({isModalOpen: false, doNotShowAgain: false});
		},

		render: function() {
			let modal = null;
			const {isModalOpen, messageType, messageData} = this.state;
			if (isModalOpen) {
				const messageInfo = CopyTable.forConfirmMessageType(
					messageType,
					messageData
				);
				let checkboxEl;
				const showOption = _.get(messageData, "doNotShowAgainOption", false);

				let confirmButtonContent = _.get(messageInfo, ["buttonTypes", "0"]);
				if (messageType === "manualLocking") {
					confirmButtonContent = (
						<div className={styles.imageText}>
							<LockIcon
								className={styles.lock}
								isLocked={true}
								lockColorOverride={styles.lockColor}
							/>
							<span>{confirmButtonContent}</span>
						</div>
					);
				}
				const confirmButton = (
					<div className={styles.blueButton} onClick={this.onConfirm}>
						{confirmButtonContent}
					</div>
				);

				const cancelButton = (
					<div className={styles.redButton} onClick={this.onNotConfirm}>
						{_.get(messageInfo, ["buttonTypes", "1"])}
					</div>
				);

				if (showOption) {
					const checkTextClassName = styles.checkText + " " + styles.message;
					checkboxEl = (
						<Checkbox
							className={styles.checkbox}
							text="Do not show this message again"
							isSelected={this.state.doNotShowAgain}
							onClick={this.toggleDoNotShow}
							checkColor="red"
							styleType="office"
							textClass={checkTextClassName}
						/>
					);
				}

				modal = (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						gateway={null}
						level="overBar"
						modalClass={styles.main}
					>
						<div className={styles.container}>
							<div className={styles.title}>{messageInfo.title}</div>
							<div className={styles.message}>{messageInfo.message}</div>
							{checkboxEl}
							<div className={styles.buttonRow}>
								{confirmButton}
								{cancelButton}
							</div>
						</div>
					</OfficeModal>
				);
			}
			return modal;
		},
	})
);
